import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { accountSchema } from '../schemas/account.schema';

/**
 * Get Account by name
 * @param accountName name of the account
 * @returns Account
 */
export function getAccounts(this: unknown, accountName: string) {
  const params = new URLSearchParams();
  params.append('name', accountName);

  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).accountsUrl}?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(accountSchema));
}
